
import React from "react";
import MapImplementation from "./MapImplementation";
import Modal from "@material-ui/core/Modal";

class RaceMap extends React.Component{

    constructor(props) {
        super(props);
        this.myRef = React.createRef();

    }

    findPlayers = () => this.players = this.props.select.map((select) => this.props.race.participants.find((participant) => participant.bib === select));

    render()
    {

    return (

        <Modal
            open={this.props.open}
            onClose={this.props.handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            >
            <div>
                <div ref={this.myRef} style={{height: '100vh', width: '100%'}}/>
                <MapImplementation
                        myRef = {this.myRef}
                        race={this.props.race}
                        players = {this.findPlayers()}
                        handleClose={this.props.handleClose}
                />
            </div>
        </Modal>)
    }
}


export default RaceMap;
